import useEnterKey from '@/utils/functions/useEnterKey'
import Button from '@dgshahr/ui-kit/Button'
import Input from '@dgshahr/ui-kit/Form/Input'

interface IPhoneNumberStepProps {
  phoneNumber: string
  error: string
  loading: boolean
  handlePhoneNumberChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleSendOtp: () => void
}

function PhoneNumberStep({
  phoneNumber,
  error,
  loading,
  handlePhoneNumberChange,
  handleSendOtp
}: IPhoneNumberStepProps) {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handlePhoneNumberChange(e)
  }
  useEnterKey(handleSendOtp)

  return (
    <div className="bg-slate-50 p-5">
      <div className="mb-5 rounded-2xl bg-white p-4 shadow-sm ring-1 ring-slate-200">
        <div className="mb-2 text-xs font-medium text-slate-500">شماره موبایل</div>
        <Input
          type="tel"
          className="!border-0 !bg-transparent !p-0 !text-base !text-slate-900"
          labelContent=""
          placeholder="0912 345 6789"
          value={phoneNumber}
          dir="ltr"
          autoFocus
          placeholderDir="rtl"
          onChange={handleInputChange}
          isError={!!error}
          errorMessage={error}
          maxLength={13}
          onClear={() =>
            handlePhoneNumberChange({
              target: { value: '' }
            } as React.ChangeEvent<HTMLInputElement>)
          }
        />
      </div>

      <Button
        variant="secondary"
        size="medium"
        isFullWidth
        className="!bg-primary-500 !text-white shadow-sm hover:!bg-primary-600"
        disabled={phoneNumber.replace(/\s/g, '').length !== 11 || loading}
        onClick={handleSendOtp}
        isLoading={loading}
      >
        دریافت کد تایید
      </Button>
    </div>
  )
}

export default PhoneNumberStep
